import classnames from 'classnames';
import React, { useCallback } from 'react';
import { IoIosCheckmark as TickIcon } from 'react-icons/io';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';

import { toggleFilter } from '../../../redux/actions';

const useStyles = createUseStyles({
  button: {
    borderRadius: 4,
    composes: [
      'is-block',
      'mt6',
      'fs12',
      'py6',
      'pl12',
      'pr24',
      'is-full-width',
    ],
    transition: 'background 0.3s, color 0.3s',
  },
  groups: {
    composes: ['mt24', 'flex-columns', 'flex-wrap', 'px6'],
  },
  icon: {
    marginRight: 6,
    transition: 'color 0.3s',
    verticalAlign: 'middle',
  },
  item: {
    composes: ['px3', 'is-flex'],
    flex: '0 auto',
  },
});

const FilterZoomComponent = React.memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const filters = useSelector(_ => _.filters);

  const clickHandler = useCallback(
    (types, visible) => dispatch(toggleFilter(types, visible)),
    [dispatch]
  );

  const hidden = filters.includes('zoomlevel');
  return (
    <button
      className={classnames(
        classes.button,
        { hidden },
        'smart-maps-tags-filter'
      )}
      type="button"
      onClick={() => clickHandler(['zoomlevel'], !hidden)}>
      <TickIcon className={classes.icon} size={22} />
      <i>Clusters par zoom</i>
    </button>
  );
});

FilterZoomComponent.displayName = 'FilterZoomComponent';

export default FilterZoomComponent;
